<template>
  <div class="container">
    <div v-if="existResume === 1">
      <p style="margin-top:10px">简历编号: {{ baseResume.SERIAL }}</p>
      <van-divider :style="baseResume.STATUS === '10' ? { color: '#da0b66',fontWeight:'800' } : ''">{{ baseResume.STATUS === '10' ? '请完善简历' : '基本信息' }}
        <van-icon
          v-if="baseResume.STATUS === '10'"
          style="float: right; line-height: 1em;color:#da0b66;font-weight: 800;font-size:14px"
          name="edit"
          size="20"
          @click="onShowEditBaseResume"
        >点我编辑</van-icon>
      </van-divider>
      <van-cell-group :border="false">
        <van-cell title="简历状态" value-class="baseResume">
          <template #value>
            {{ baseResume.STATUS === "0" ? "未处理" : "已处理" }}
          </template>
        </van-cell>
        <van-cell
          title="意向门店"
          :value="baseResume.ORGANLABEL"
          value-class="baseResume"
        />
        <van-cell
          title="意向部门"
          :value="baseResume.DEPARTLABEL"
          value-class="baseResume"
        />
        <van-cell
          title="意向岗位"
          :value="baseResume.POSTLABEL"
          value-class="baseResume"
        />
        <van-cell
          title="招聘来源"
          :value="baseResume.RECRUITSOURCELABEL"
          value-class="baseResume"
        />
        <van-cell
          title="推荐人"
          :value="baseResume.INTRODUCER"
          value-class="baseResume"
        />
        <van-cell
          title="有亲朋在西亚工作"
          :value="baseResume.PERSON_RELATION === '0' ? '否' : '是'"
          value-class="baseResume"
        />
        <van-cell
          title="照片"
          value-class="baseResume"
        >
          <template #value>
            <van-image
              width="135"
              height="160"
              :src="baseResume.PHOTO"
            />
          </template>
        </van-cell>
        <van-cell
          title="姓名"
          :value="baseResume.NAME"
          value-class="baseResume"
        />
        <van-cell
          title="性别"
          :value="baseResume.GENDER === '1' ? '男' : '女'"
          value-class="baseResume"
        />
        <van-cell
          title="身份证"
          :value="baseResume.SFID"
          value-class="baseResume"
        />
        <van-cell
          title="身份证有效期"
          :value="baseResume.SFIDEDATE"
          value-class="baseResume"
        />
        <van-cell
          title="婚姻状况"
          :value="baseResume.MARRIED === '1' ? '未婚' : '已婚'"
          value-class="baseResume"
        />
        <van-cell
          title="政治面貌"
          :value="baseResume.POLITICALLABEL"
          value-class="baseResume"
        />
        <van-cell
          title="民族"
          :value="baseResume.NATIONLABEL"
          value-class="baseResume"
        />
        <van-cell
          title="户口所在地"
          :value="baseResume.REGHOUSELABEL"
          value-class="baseResume"
        />
        <van-cell
          title="身份证住址"
          :value="baseResume.SFIDADDR"
          value-class="baseResume"
        />
        <van-cell
          title="联系方式"
          :value="baseResume.PHONE"
          value-class="baseResume"
        />
        <van-cell
          title="兴趣爱好"
          :value="baseResume.INTEREST"
          value-class="baseResume"
        />
        <van-cell
          title="身高(cm)"
          :value="baseResume.HEIGHT"
          value-class="baseResume"
        />
        <van-cell
          title="体重(kg)"
          :value="baseResume.WEIGHT"
          value-class="baseResume"
        />
        <van-cell
          title="电子邮件"
          :value="baseResume.EMAIL"
          value-class="baseResume"
        />
        <van-cell
          v-show="baseResume.JOB_TYPE !== '1'"
          title="原单位劳动关系"
          :value="baseResume.WORKSTATUS === '1' ? '已解除' : '未解除'"
          value-class="baseResume"
        />
        <van-divider>教育经历(最高学历)</van-divider>
        <van-cell
          title="最高学历"
          :value="baseResume.EDUCATIONLABEL"
          value-class="baseResume"
        />
        <van-cell
          title="毕业院校"
          :value="baseResume.EDUCSCHOOL"
          value-class="baseResume"
        />
        <van-cell
          title="学习方式"
          :value="baseResume.EDUCTYPELABEL"
          value-class="baseResume"
        />
        <van-cell
          title="开始时间"
          :value="baseResume.EDUCSTART"
          value-class="baseResume"
        />
        <van-cell
          title="结束时间"
          :value="baseResume.EDUCEND"
          value-class="baseResume"
        />
        <van-cell
          title="专业分类"
          :value="baseResume.SPECTYPE"
          value-class="baseResume"
        />
        <van-cell
          title="专业名称"
          :value="baseResume.SPECNAME"
          value-class="baseResume"
        />
        <template v-if="baseResume.FIRSTEDUCATIONLABEL">
          <van-divider>教育经历(其他学历)</van-divider>
          <van-cell
            title="其他学历"
            :value="baseResume.FIRSTEDUCATIONLABEL"
            value-class="baseResume"
          />
          <van-cell
            title="毕业院校"
            :value="baseResume.FIRSTEDUCSCHOOL"
            value-class="baseResume"
          />
          <van-cell
            title="学习方式"
            :value="baseResume.FIRSTEDUCTYPELABEL"
            value-class="baseResume"
          />
          <van-cell
            title="开始时间"
            :value="baseResume.FIRSTEDUCSTART"
            value-class="baseResume"
          />
          <van-cell
            title="结束时间"
            :value="baseResume.FIRSTEDUCEND"
            value-class="baseResume"
          />
          <van-cell
            title="专业分类"
            :value="baseResume.FIRSTSPECTYPE"
            value-class="baseResume"
          />
          <van-cell
            title="专业名称"
            :value="baseResume.FIRSTSPECNAME"
            value-class="baseResume"
          />

        </template>
      </van-cell-group>
      <van-cell
        title="曾任学生干部"
        :value="baseResume.ISSCADRE === '1' ? '是' : '否'"
        value-class="baseResume"
      />
      <van-cell
        v-show="baseResume.ISSCADRE === '1'"
        title="学生干部职位"
        :value="baseResume.SCADREPOST"
        value-class="baseResume"
      />
      <van-divider v-show="baseResume.workHis.length > 0 && baseResume.jobtype !== '1'">工作经历</van-divider>
      <van-cell-group>
        <van-cell
          v-for="item in baseResume.workHis"
          :key="item.ID"
          center
          border
          title-style="text-align:left;"
        >
          <template #title>
            <div style="width: 20em">{{ item.UNIT }}</div>
            <van-tag color="#d2065c">{{ item.WORK }}</van-tag>
          </template>
          <template v-if="baseResume.STATUS === '10'" #value>
            <van-space>
              <van-icon name="edit" size="20" @click="onEditWorkHis(item)" />
              <van-icon name="delete" size="20" @click="onDeleteWorkHis(item)" />
            </van-space>
          </template>
          <template #label>
            {{ item.WORKSTART }} 至 {{ item.WORKEND }}
          </template>
        </van-cell>
        <van-button
          v-show="baseResume.workHis.length < 3 && baseResume.STATUS === '10'"
          style="margin-top: 16px"
          round
          icon="plus"
          type="primary"
          color="#da0b66"
          size="small"
          @click="onShowAddMyWorkHis"
        >添加工作经历
        </van-button>
      </van-cell-group>
      <van-divider v-show="baseResume.xyWorkHis.length > 0">西亚工作经历</van-divider>
      <van-cell-group :border="false" style="margin: 16px">
        <van-cell
          v-for="item in baseResume.xyWorkHis"
          :key="item.ID"
          center
          border
          title-style="text-align:left;"
          value-class="workHis"
        >
          <template #title>
            <div style="width: 20em">{{ item.ORGAN + item.DEPART }}</div>
            <van-tag color="#d2065c">{{ item.WORK }}</van-tag>
          </template>
          <template #label>
            {{ item.WORKSTART }} 至 {{ item.WORKEND }}
          </template>
        </van-cell>
      </van-cell-group>
      <van-divider v-show="baseResume.familyContact.length > 0">家庭成员/紧急联系人</van-divider>
      <van-cell-group>
        <van-cell v-for="item in baseResume.familyContact" :key="item.id" center border title-style="text-align:left">
          <template #title>
            <div style="width: 20em;">{{ item.CNAME }}
              <van-tag style="margin-left: 10px;" color="#d2065c">{{
                item.NEXUS
              }}
              </van-tag>
            </div>
          </template>
          <template v-if="baseResume.STATUS === '10'" #value>
            <van-space>
              <van-icon name="edit" size="20" @click="onEditFamilyContact(item)" />
              <van-icon name="delete" size="20" @click="onDeleteFamilyContact(item)" />
            </van-space>
          </template>
          <template #label>
            {{ item.TEL }}
          </template>
        </van-cell>
        <van-button
          v-show="baseResume.familyContact.length < 3 && baseResume.STATUS === '10'"
          style="margin-top: 16px"
          round
          icon="plus"
          type="primary"
          color="#da0b66"
          size="small"
          @click="onAddFamilyContact"
        >添加家庭成员/紧急联系人
        </van-button>
      </van-cell-group></div>
    <div v-if="existResume === 0" style="margin-top: 35%">
      <van-icon name="warning-o" size="100" color="#e4e4e4" />
      <div style="padding: 16px">
        <span
          style="color: #bdbdbd; font-weight: 800; text-align: center"
        >您还没有填写过简历</span>
        <van-button
          block
          color="#da0b66"
          type="primary"
          icon="envelop-o"
          size="small"
          style="margin-top: 16px"
          to="/"
        >去申请岗位</van-button>
      </div>
    </div>
    <div class="van-safe-area-bottom" />
    <!-- 编辑基础简历 -->
    <van-dialog
      v-model:show="showEditBaseResume"
      lazy-render
      lock-scroll
      style="top: 50%; overflow: scroll"
      :overlay="false"
      width="100%"
      :show-cancel-button="true"
      confirm-button-text="保存简历"
      :before-close="onBaseResumeBeforeClose"
    >
      <EditBaseResume
        ref="editBaseResume"
        :resume-data="resumeData"
      />
    </van-dialog>
    <!-- 添加工作经历 -->
    <van-dialog
      v-model:show="showAddMyWorkHis"
      width="90%"
      :show-cancel-button="true"
      :before-close="onAddBeforeClose"
      confirm-button-text="添加"
    >
      <AddMyWorkHis ref="addMyWorkHis" />
    </van-dialog>
    <!-- 编辑工作经历 -->
    <van-dialog
      v-model:show="showEditMyWorkHis"
      width="90%"
      :show-cancel-button="true"
      :before-close="onEditBeforeClose"
      confirm-button-text="添加"
    >
      <EditMyWorkHis
        ref="editMyWorkHis"
        :work-his-data="workHisData"
      />
    </van-dialog>
    <!--家庭成员紧急联系人添加-->
    <van-dialog
      v-model:show="showAddFamilyContact"
      width="90%"
      :show-cancel-button="true"
      :before-close="onAddFamilyContactBeforeClose"
      confirm-button-text="添加"
    >
      <AddFamilyContact ref="addFamilyContact" />
    </van-dialog>
    <!-- 家庭成员紧急联系人编辑 -->
    <van-dialog
      v-model:show="showEditFamilyContact"
      width="90%"
      :show-cancel-button="true"
      :before-close="onEditFamilyContactBeforeClose"
      confirm-button-text="保存"
    >
      <EditFamilyContact ref="editFamilyContact" :family-contact-data="familyContactData" />
    </van-dialog>
  </div>
</template>
<script>
import { getResume, addWorkHis, editWorkHis, deleteWorkHis, editResume, addFamilyContact, editFamilyContact, deleteFamilyContact } from '@/api/api.js'
import AddMyWorkHis from '@/views/User/AddMyWorkHis.vue'
import EditMyWorkHis from '@/views/User/EditMyWorkHis.vue'
import EditBaseResume from '@/views/User/EditBaseResume.vue'
import EditFamilyContact from '../Resume/EditFamilyContact.vue'
import AddFamilyContact from '../Resume/AddFamilyContact.vue'
export default {
  components: { EditMyWorkHis, EditBaseResume, AddMyWorkHis, EditFamilyContact, AddFamilyContact },
  setup() {},
  data() {
    return {
      existResume: 3,
      showAddMyWorkHis: false,
      showEditMyWorkHis: false,
      showAddFamilyContact: false,
      showEditFamilyContact: false,
      showEditBaseResume: false,
      resumeData: {},
      workHisData: [],
      baseResume: [],
      familyContactData: {},
      familyContactList: []
    }
  },
  async created() {
    await this.getResume()
  },
  methods: {
    getResume() {
      const toast = this.$toast.loading({
        message: '正在加载',
        forbidClick: true,
        loadingType: 'spinner'
      })
      setTimeout(() => {
        getResume({ openid: sessionStorage.getItem('openid') }).then(
          (response) => {
            const res = response.data
            if (res.code === 200) {
              if (res.data) {
                this.existResume = 1
                this.baseResume = res.data
                this.baseResume.PHOTO = process.env.NODE_ENV === 'development' ? 'http://localhost:45750/SeekerPhoto/' + this.baseResume.PHOTO : 'http://hr.xiya3333.com/SeekerPhoto/' + this.baseResume.PHOTO
              } else {
                this.existResume = 0
              }
            }
            toast.clear()
          }
        ).catch(error => {
          this.$toast.fail(error.msg)
        })
      }, 300)
    },
    onShowEditBaseResume() {
      this.showEditBaseResume = true
      this.resumeData = JSON.parse(JSON.stringify(this.baseResume))
    },
    onBaseResumeBeforeClose(action) {
      if (action === 'cancel') {
        this.$refs.editBaseResume.onReset()
        this.$refs.editBaseResume.form = {}
        return true
      } else {
        Promise.all([this.$refs.editBaseResume.validateForm()]).then(() => {
          const toast = this.$toast.loading({
            forbidClick: true,
            loadingType: 'spinner'
          })
          setTimeout(() => {
            toast.clear()
            editResume({ editResumeData: this.$refs.editBaseResume.form }).then(
              response => {
                const res = response.data
                this.$toast.success({
                  message: res.msg,
                  onClose: () => {
                    this.getResume()
                  }
                })
              }
            ).catch(error => {
              this.$toast.fail(error.msg)
            })
            this.$refs.editBaseResume.onReset()
            this.$refs.editBaseResume.form = {}
          }, 300)
          this.showEditBaseResume = false
        })
      }
    },
    onShowAddMyWorkHis() {
      this.showAddMyWorkHis = true
    },
    onAddBeforeClose(action) {
      if (action === 'cancel') {
        this.$refs.addMyWorkHis.onReset()
        this.$refs.addMyWorkHis.form = {}
        return true
      } else {
        Promise.all([this.$refs.addMyWorkHis.validateForm()]).then(() => {
          const toast = this.$toast.loading({
            forbidClick: true,
            loadingType: 'spinner'
          })
          setTimeout(() => {
            toast.clear()
            this.$refs.addMyWorkHis.form.guid = this.baseResume.GUID
            addWorkHis({ addWorkHisData: this.$refs.addMyWorkHis.form }).then(
              response => {
                const res = response.data
                this.$toast.success({
                  message: res.msg,
                  onClose: () => {
                    this.getResume()
                  }
                })
              }
            ).catch(error => {
              this.$toast.fail(error.msg)
            })
            this.$refs.addMyWorkHis.onReset()
            this.$refs.addMyWorkHis.form = {}
          }, 300)
          this.showAddMyWorkHis = false
        })
      }
    },
    onEditWorkHis(item) {
      item.guid = this.baseResume.GUID
      this.workHisData = JSON.parse(JSON.stringify(item))
      this.showEditMyWorkHis = true
    },
    onEditBeforeClose(action) {
      if (action === 'cancel') {
        this.$refs.editMyWorkHis.onReset()
        this.$refs.editMyWorkHis.form = {}
        return true
      } else {
        Promise.all([this.$refs.editMyWorkHis.validateForm()]).then(() => {
          const toast = this.$toast.loading({
            forbidClick: true,
            loadingType: 'spinner'
          })
          setTimeout(() => {
            toast.clear()
            editWorkHis({ editWorkHisData: this.$refs.editMyWorkHis.form }).then(
              response => {
                const res = response.data
                this.$toast.success({
                  message: res.msg,
                  onClose: () => {
                    this.getResume()
                  }
                })
              }
            ).catch(error => {
              this.$toast.fail(error.msg)
            })
            this.$refs.editMyWorkHis.onReset()
            this.$refs.editMyWorkHis.form = {}
          }, 300)
          this.showEditMyWorkHis = false
        })
      }
    },
    onDeleteWorkHis(item) {
      if (this.baseResume.workHis.length === 1) {
        this.$toast('最少要保留一段工作经历')
        return
      }
      const toast = this.$toast.loading({
        forbidClick: true,
        loadingType: 'spinner'
      })
      setTimeout(() => {
        toast.clear()
        deleteWorkHis({ guid: item.GUID, id: item.ID }).then(
          response => {
            const res = response.data
            this.$toast.success({
              message: res.msg,
              onClose: () => {
                this.getResume()
              }
            })
          }
        ).catch(error => {
          this.$toast.fail(error.msg)
        })
      }, 300)
    },
    onAddFamilyContact() {
      if (this.baseResume.familyContact.length >= 3) {
        this.$toast('最多只可以填写3位家庭成员紧急联系人')
        return
      }
      this.showAddFamilyContact = true
    },
    onAddFamilyContactBeforeClose(action) {
      if (action === 'cancel') {
        this.$refs.addFamilyContact.onReset()
        this.$refs.addFamilyContact.form = {}
        return true
      } else {
        let flag = false
        this.baseResume.familyContact.filter(item => {
          if (item.TEL === this.$refs.addFamilyContact.form.tel) {
            flag = true
          }
        })
        if (flag) {
          this.$toast('不能添加同样的手机号码')
          return false
        }
        Promise.all([this.$refs.addFamilyContact.validateForm()]).then(() => {
          const toast = this.$toast.loading({
            forbidClick: true,
            loadingType: 'spinner'
          })
          setTimeout(() => {
            toast.clear()
            this.$refs.addFamilyContact.form.guid = this.baseResume.GUID
            addFamilyContact({ addFamilyContactData: this.$refs.addFamilyContact.form }).then(
              response => {
                const res = response.data
                this.$toast.success({
                  message: res.msg,
                  onClose: () => {
                    this.getResume()
                  }
                })
              }
            ).catch(error => {
              this.$toast.fail(error.msg)
            })
            this.$refs.addFamilyContact.onReset()
            this.$refs.addFamilyContact.form = {}
          }, 300)
          this.showAddFamilyContact = false
        })
      }
    },
    onEditFamilyContact(item) {
      this.familyContactData = { id: item.ID, guid: this.baseResume.GUID, name: item.CNAME, age: item.AGE, tel: item.TEL, relation: item.NEXUS, unit: item.UNIT }
      this.showEditFamilyContact = true
    },
    onEditFamilyContactBeforeClose(action) {
      if (action === 'cancel') {
        this.$refs.editFamilyContact.onReset()
        return true
      } else {
        let flag = false
        this.baseResume.familyContact.filter(item => {
          if (item.TEL === this.$refs.editFamilyContact.form.tel && item.ID !== this.$refs.editFamilyContact.form.id) {
            flag = true
          }
        })
        if (flag) {
          this.$toast('不能添加同样的手机号码')
          return false
        }
        Promise.all([this.$refs.editFamilyContact.validateForm()]).then(() => {
          setTimeout(() => {
            this.$toast.clear()
            editFamilyContact({ editFamilyContactData: this.$refs.editFamilyContact.form }).then(
              response => {
                const res = response.data
                this.$toast.success({
                  message: res.msg,
                  onClose: () => {
                    this.getResume()
                  }
                })
              }
            ).catch(error => {
              this.$toast.fail(error.msg)
            })
            this.$refs.editFamilyContact.onReset()
            this.$refs.editFamilyContact.form = {}
          }, 300)
          this.showEditFamilyContact = false
        })
      }
    },
    onDeleteFamilyContact(item) {
      if (this.baseResume.familyContact.length === 2) {
        this.$toast('最少要保留两个家庭紧急联系人')
        return
      }
      const toast = this.$toast.loading({
        forbidClick: true,
        loadingType: 'spinner'
      })
      setTimeout(() => {
        toast.clear()
        deleteFamilyContact({ guid: this.baseResume.GUID, id: item.ID }).then(
          response => {
            const res = response.data
            this.$toast.success({
              message: res.msg,
              onClose: () => {
                this.getResume()
              }
            })
          }
        ).catch(error => {
          this.$toast.fail(error.msg)
        })
      }, 300)
    }
  }
}
</script>
<style scoped>
::v-deep .baseResume {
  text-align: left !important;
}
::v-deep .workHis {
  margin-right: 2em;
}
::v-deep .van-cell__title {
  text-align: left !important;
  margin-left: 1em;
}
::v-deep .van-cell-group__title {
  text-align: left !important;
  margin-left: 1em;
}
</style>
